const $window = $(window);

const handleProductBar = () => {
  const $header = $('.header');
  const $headerBody = $header.find('.header__body');
  const $productContainer = $('.product .product__form');

  if ($productContainer.length === 0) {
    return;
  }

  const isProductBarVisible = ($window.scrollTop() + $headerBody.outerHeight()) > ($productContainer.offset().top + $productContainer.outerHeight());

  $header.toggleClass('header--product-bar', isProductBarVisible);
}

$window.on('load resize scroll', function() {
  handleProductBar();
});
